import script from "./AnnouncementDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementDetail.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementDetail.vue?vue&type=style&index=0&id=652044ba&lang=css"

const __exports__ = script;

export default __exports__